<template lang='pug' src='./virtual-thank-you.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  computed: {
    props () {
      return {
        videoUrl: 'https://starsmilesorthopedo.com/wp-content/uploads/VirtualConsultation-compressed.mov'
      }
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// virtual-thank-you.vue?cece2858